import { addBusinessDays } from "date-fns/fp";

/**
 * Get a date offset by the specified number of Weekdays.
 * @param offsetWeekDays Number of weekdays after the baseDate
 * @param baseDate Date to offset by offsetWeekDays (defaults to today)
 */
export const getOffsetDateWeekdays = (offsetWeekDays: number, baseDate = new Date()): Date =>
  addBusinessDays(offsetWeekDays, baseDate);
